// @flow
import React from "react";
import { Segment, Form } from "semantic-ui-react";
import classnames from "classnames";
import type { FieldProps } from "redux-form";

import Styles from "./IconOptions.module.scss";
import "./IconOptions.scss";
import { ReactComponent as SunIcon } from "Commons/Assets/icons/sun.svg";
import { ReactComponent as WorldIcon } from "Commons/Assets/icons/world.svg";
import { ReactComponent as CoinsIcon } from "Commons/Assets/icons/coins.svg";
import { ReactComponent as HouseIcon } from "Commons/Assets/icons/house.svg";
import { ReactComponent as TruckIcon } from "Commons/Assets/icons/truck.svg";
import { ReactComponent as SignUpIcon } from "Commons/Assets/icons/signup.svg";
import { ReactComponent as SignedIcon } from "Commons/Assets/icons/signed.svg";
import { ReactComponent as CompanyIcon } from "Commons/Assets/icons/company.svg";
import { ReactComponent as BankIcon } from "Commons/Assets/icons/bank.svg";
import { ReactComponent as Person1Icon } from "Commons/Assets/icons/1_person.svg";
import { ReactComponent as Person2Icon } from "Commons/Assets/icons/2_person.svg";
import { ReactComponent as Person3Icon } from "Commons/Assets/icons/3_person.svg";
import { ReactComponent as Person4Icon } from "Commons/Assets/icons/4_person.svg";
import { ReactComponent as IndustryIcon } from "Commons/Assets/icons/industry.svg";
import { ReactComponent as Industry1Icon } from "Commons/Assets/icons/1_industry.svg";
import { ReactComponent as Industry2Icon } from "Commons/Assets/icons/2_industry.svg";
import { ReactComponent as Industry3Icon } from "Commons/Assets/icons/3_industry.svg";
import { ReactComponent as Industry4Icon } from "Commons/Assets/icons/4_industry.svg";
import { ReactComponent as CircularArrow } from "Commons/Assets/icons/circular_arrow.svg";
import { CategoryIcon } from "Commons/Modules/category";

const ICONS = {
  sun: SunIcon,
  world: WorldIcon,
  coins: CoinsIcon,
  house: HouseIcon,
  truck: TruckIcon,
  signup: SignUpIcon,
  signed: SignedIcon,
  company: CompanyIcon,
  bank: BankIcon,
  person1: Person1Icon,
  person2: Person2Icon,
  person3: Person3Icon,
  person4: Person4Icon,
  industry: IndustryIcon,
  industry1: Industry1Icon,
  industry2: Industry2Icon,
  industry3: Industry3Icon,
  industry4: Industry4Icon,
  circulararrow: CircularArrow,
  strom: function StromIcon() {
    return <CategoryIcon.Icon name="strom" size="huge" />;
  },
  gas: function GasIcon() {
    return <CategoryIcon.Icon name="gas" size="huge" />;
  },
};

type IconProps = {|
  name: $Keys<typeof ICONS>,
  className?: string,
|};

export function Icon(props: IconProps) {
  const Component = ICONS[props.name];
  return Component ? <Component className={props.className} /> : null;
}

function getHeight(options) {
  const length = options.length;

  const SIZES = {
    "2": "33.5vw",
    "3": "23.5vw",
    "4": "100%",
  };

  return SIZES[length];
}

type Props = {|
  options: {
    value: boolean | string,
    icon: $Keys<typeof ICONS>,
    label: string,
    dataCy: string,
  }[],
  noPadding?: boolean,
|} & FieldProps;

function IconOptions(props: Props) {
  const { options, input, noPadding } = props;

  return (
    <Form.Field className={Styles["container"]} role="radio">
      {options.map((option, i, desktop) => {
        return (
          <div
            key={i}
            className={Styles["option"]}
            id={i}
            role="option"
            aria-checked={option.value === input.value}
            aria-selected={option.value === input.value}
            onClick={() => {
              input.onChange(option.value);

              if (props.onChange) {
                props.onChange(option.value);
              }
            }}
          >
            <Segment
              padded
              className={classnames(
                Styles["icon"],
                option.value === input.value ? "change-service-mobile-active" : "change-service-mobile-inactive",
                desktop && Styles["desktop"]
              )}
              style={{
                height: getHeight(options),
              }}
              data-cy={option.value}
            >
              <Icon name={option.icon} />
            </Segment>
            <p className={Styles.label}>{option.label}</p>
          </div>
        );
      })}
      {!noPadding && options.length < 3 && <div className={Styles["filler-div"]} />}
    </Form.Field>
  );
}

export { IconOptions };
